export class BuyButtonConfig {

    constructor(shopifyData) {
        this.buttonType = shopifyData.buyButtonType;
        this.shopifyId = shopifyData.shopifyId;
        this.buttonDestination = 'modal';
    }

    setButtonDestination(buttonDestination) {
        this.buttonDestination = buttonDestination;
    }

}

// Buy Button Modul
export function loadBuyButtonModule(container, buyButtonConfig) {
    loadShopifyScript(function() {
        initializeBuyButton(container, buyButtonConfig);
    });
}

function loadShopifyScript(callback) {
    const scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
    if (window.ShopifyBuy) {
        if (window.ShopifyBuy.UI) {
            callback();
        } else {
            loadScript();
        }
    } else {
        loadScript();
    }

    function loadScript() {
        var script = document.createElement('script');
        script.async = true;
        script.src = scriptURL;
        script.onload = callback;
        (document.head || document.body).appendChild(script);
    }
}

function initializeBuyButton(container, buyButtonConfig) {
    var client = ShopifyBuy.buildClient({
        domain: 'lokl-hamburg.myshopify.com',
        storefrontAccessToken: 'ae9a4e1afbe018f9b47c06e7a5041210',
    });

    var containerId = container.getAttribute('id');

    ShopifyBuy.UI.onReady(client).then(function(ui) {

        if (buyButtonConfig.buttonType.toLowerCase() === 'product') {
            createProductBuyButton(ui, buyButtonConfig, containerId);
        } else if (buyButtonConfig.buttonType.toLowerCase() === 'collection') {
            createCollectionBuyButton(ui, buyButtonConfig, containerId);
        }
    });
}

function createCollectionBuyButton(ui, buyButtonConfig, containerId) {
    ui.createComponent('collection', {
        id: buyButtonConfig.shopifyId,
        node: document.querySelector(`#${containerId} .lokl-ad-container`),
        moneyFormat: '%E2%82%AC%7B%7Bamount_with_comma_separator%7D%7D',
        options: {
            "product": {
                "iframe": false,
                "buttonDestination": buyButtonConfig.buttonDestination,
                "contents": {
                    "options": false
                },
                "text": {
                    "button": "Details"
                },
                events: {
                    afterInit: function (product) {
                        console.log("Product View Event Triggered id: " + product.id + " handle: ", product.handle );
                        if (typeof _paq !== 'undefined') {
                            _paq.push(['trackEvent', 'Shopify', 'Product View', product.handle]);
                        }
                    },
                    addVariantToCart: function (variant) {
                        console.log("Add to Cart Event Triggered ", variant);
                        if (typeof _paq !== 'undefined') {
                            _paq.push(['trackEvent', 'Shopify', 'Add to Cart', variant.title]);
                        }
                    },
                    openCheckout: function (component) {
                        console.log("Checkout Event Triggered");
                        if (typeof _paq !== 'undefined') {
                            _paq.push(['trackEvent', 'Shopify', 'Checkout', component.id]);
                        }
                    }
                }
            },
            "productSet": {
                "styles": {
                    "products": {
                        "@media (min-width: 601px)": {
                            "margin-left": "-20px"
                        }
                    }
                }
            },
            "modalProduct": {
                "contents": {
                    "img": false,
                    "imgWithCarousel": true,
                    "button": false,
                    "buttonWithQuantity": true
                },
                "styles": {
                    "product": {
                        "@media (min-width: 601px)": {
                            "max-width": "100%",
                            "margin-left": "0px",
                            "margin-bottom": "0px"
                        }
                    },
                    "button": {
                        "font-size": "18px",
                        "padding-top": "17px",
                        "padding-bottom": "17px",
                        "padding-left": "36px",
                        "padding-right": "36px"
                    },
                    "quantityInput": {
                        "font-size": "18px",
                        "padding-top": "17px",
                        "padding-bottom": "17px"
                    }
                },
                "text": {
                    "button": "Zum Warenkorb hinzufügen"
                }
            },
            "option": {},
            "cart": {
                "styles": {
                    "button": {
                        "font-size": "18px",
                        "padding-top": "17px",
                        "padding-bottom": "17px"
                    }
                },
                "text": {
                    "title": "Warenkorb",
                    "total": "Zwischensumme",
                    "empty": "Ihr Warenkorb ist leer.",
                    "notice": "Versand und Rabattcodes werden in der Kasse ermittelt.",
                    "button": "Zur Kasse",
                    "noteDescription": "Bestellanmerkungen für Anbieter"
                },
                "contents": {
                    "note": true
                },
                events: {
                    openCheckout: function (component) {
                        console.log("Checkout from Cart Event Triggered");
                        if (typeof _paq !== 'undefined') {
                            _paq.push(['trackEvent', 'Shopify', 'Checkout from Cart', component.cart.id]);
                        }
                    }
                }
            },
            "toggle": {
                "styles": {
                    "count": {
                        "font-size": "18px"
                    }
                }
            }
        }
    });
}

function createProductBuyButton(ui, buyButtonConfig, containerId) {
    ui.createComponent('product', {
        id: buyButtonConfig.shopifyId,
        node: document.querySelector(`#${containerId} .lokl-ad-container`),
        moneyFormat: '%E2%82%AC%7B%7Bamount_with_comma_separator%7D%7D',
        options: {
            product: {
                iframe: false,
                buttonDestination: buyButtonConfig.buttonDestination,
                contents: {
                    "options": false
                },
                text: {
                    "button": "Details"
                },
                events: {
                    afterInit: function (product) {
                        console.log("Product View Event Triggered id: " + product.id + " handle: ", product.handle );
                        if (typeof _paq !== 'undefined') {
                            _paq.push(['trackEvent', 'Shopify', 'Product View', product.handle]);
                        }
                    },
                    addVariantToCart: function (variant) {
                        console.log("Add to Cart Event Triggered ", variant);
                        if (typeof _paq !== 'undefined') {
                            _paq.push(['trackEvent', 'Shopify', 'Add to Cart', variant.title]);
                        }
                    },
                    openCheckout: function (component) {
                        console.log("Checkout Event Triggered");
                        if (typeof _paq !== 'undefined') {
                            _paq.push(['trackEvent', 'Shopify', 'Checkout', component.id]);
                        }
                    }
                }
            },
            "productSet": {
                "styles": {
                    "products": {
                        "@media (min-width: 601px)": {
                            "margin-left": "-20px"
                        }
                    }
                }
            },
            "modalProduct": {
                "contents": {
                    "img": false,
                    "imgWithCarousel": true,
                    "button": false,
                    "buttonWithQuantity": true
                },
                "styles": {
                    "product": {
                        "@media (min-width: 601px)": {
                            "max-width": "100%",
                            "margin-left": "0px",
                            "margin-bottom": "0px"
                        }
                    },
                    "button": {
                        "font-size": "18px",
                        "padding-top": "17px",
                        "padding-bottom": "17px",
                        "padding-left": "36px",
                        "padding-right": "36px"
                    },
                    "quantityInput": {
                        "font-size": "18px",
                        "padding-top": "17px",
                        "padding-bottom": "17px"
                    }
                },
                "text": {
                    "button": "Zum Warenkorb hinzufügen"
                }
            },
            "option": {},
            "cart": {
                "styles": {
                    "button": {
                        "font-size": "18px",
                        "padding-top": "17px",
                        "padding-bottom": "17px"
                    }
                },
                "text": {
                    "title": "Warenkorb",
                    "total": "Zwischensumme",
                    "empty": "Ihr Warenkorb ist leer.",
                    "notice": "Versand und Rabattcodes werden in der Kasse ermittelt.",
                    "button": "Zur Kasse",
                    "noteDescription": "Bestellanmerkungen für Anbieter"
                },
                "contents": {
                    "note": true
                },
                events: {
                    openCheckout: function (component) {
                        console.log("Checkout from Cart Event Triggered");
                        if (typeof _paq !== 'undefined') {
                            _paq.push(['trackEvent', 'Shopify', 'Checkout from Cart', component.cart.id]);
                        }
                        TrackingModule.trackEvent('ProductView', {
                            productId: product.id,
                            handle: product.handle
                        });
                    }
                }
            },
            "toggle": {
                "styles": {
                    "count": {
                        "font-size": "18px"
                    }
                }
            }
        }
    });
}
